import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';

export type FileOverviewTableColumnName =
  | 'icon'
  | 'name'
  | 'size'
  | 'course';

export interface FileOverviewTableRow {
    id: string;
    icon?: string;
    name: string;
    size?: string;
    course?: string;
};

@Component({
    selector: 'asg-file-overview-table',
    templateUrl: './file-overview-table.component.html',
    styleUrls: ['./file-overview-table.component.scss'],
    standalone: true,
    imports: [MatTableModule, TranslateModule]
})
export class FileOverviewTableComponent {
    @Input({ required: true }) columnNames: FileOverviewTableColumnName[] = [];

    @Input({ required: true })
    public set dataSource(value: FileOverviewTableRow[]) {
        this._dataSource = value ?? [];
        this.selectedRowId = null;
    }

    public get dataSource(): FileOverviewTableRow[] {
        return this._dataSource;
    }

    @Output() rowSelected = new EventEmitter<string>();

    public selectedRowId: string | null = null;
    private _dataSource: FileOverviewTableRow[] = [];

    public onRowClick(rowId: string): void {
        this.selectedRowId = rowId;
        this.rowSelected.emit(rowId);
    }

    public isIconUrl(icon: string | undefined): boolean {
        if (!icon) {
            return false;
        }

        return /^(https?:\/\/|data:image\/|blob:|\/|\.\/|\.\.\/)/i.test(icon);
    }
}
